import { Box, Button, Typography } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";

export interface IDialogProps {
    data: any[];
    onClose?: any;
}

export default function DialogList({ data, onClose }: IDialogProps) {
    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open
        >
            <DialogTitle>
                Resultado do processamento
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        onClose();
                    }}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box>
                    <Typography>Lista de erros:</Typography>
                    {data && data.length > 0 && (
                        <ul>
                            {data.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <Typography>{item}</Typography>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </Box>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <Button
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
